import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    borderTop: `0.1px solid ${mainColor.colorAdditional}`
  },
  inputs: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  itemtext: { paddingLeft: UNIT * 0.3125 },
  listItem: { width: UNIT * 13.75 },
  title: {
    fontSize: UNIT * 1.25,
    padding: UNIT * 0.3125,
    color: 'gray'
  },
  pos: {
    display: 'inline-block',
    fontSize: UNIT * 0.75,
    color: 'grey'
  },
  icon: {
    maginLeft: UNIT * 1.25,
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`
  },
  textField: {
    marginBottom: 8
  },
  feeStyle: {
    marginTop: 'auto',
    marginBottom: 'auto',
    fontSize: UNIT * 0.9325,
    padding: '0 10px 0 10px',
    width: '100%',
    paddingTop: UNIT * 1.125
  },
  inputStyle: { width: '100%' },
  contentStyle: { padding: UNIT },
  contactStyle: { paddingRight: UNIT * 1.25, marginTop: 0 },
  separator: {
    display: 'flex',
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    height: 1,
    marginTop: UNIT,
    marginBottom: UNIT,
    marginLeft: UNIT * 0.625,
    marginRight: UNIT * 0.625
  },
  labelStyle: {
    fontSize: UNIT * 0.875
  },
  removeIcon: {
    width: UNIT,
    height: UNIT,
    fontSize: UNIT * 0.9375,
    alignSelf: 'center',

    color: mainColor.colorWhite
  },
  slotLabel: {
    color: `rgba(${mainColor.rgb}, 0.8)`,
    marginLeft: UNIT * 0.625,
    fontSize: UNIT,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  textStyle: { fontSize: UNIT, marginLeft: UNIT * 0.625, marginRight: UNIT * 0.625 },
  itemHeader: {
    display: 'flex',

    flexDirection: 'row',
    padding: UNIT * 1.25
  },
  dayLabel: {
    fontSize: UNIT
  },
  limitLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: UNIT
  },
  limitInput: {
    width: UNIT * 3,
    marginLeft: UNIT * 0.5,
    marginRight: UNIT * 0.5
  },

  paperStyle: {
    boxShadow: `1px 3px 5px #ccc`
  },
  inputAdorment: {
    color: mainColor.secondaryColor,
    fontSize: UNIT
  },
  boldText: {
    fontSize: UNIT,
    fontWeight: 'bolder'
  }
});
